import { Injectable } from '@angular/core';
import { getQueryParams } from '@pin-up-global/common';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { ApiService, ListResponse } from '@shared/abstraction';
import { Observable } from 'rxjs';
import { FlowContentItem, FlowContentItemTranslation, FlowContentItemTranslationStatistics, FlowsLocalsReq, GetTranslationsStatisticsReq, PatchFlowContentReq } from './flows-localization.abstraction';

@Injectable({ providedIn: 'root' })
export class FlowsLocalizationApiService extends ApiService {
  readonly #apiController: string = '@api/settings/intl';
  isLoading$ = this._isLoading$;

  getTranslationsStatistics(params: GetTranslationsStatisticsReq): Observable<FlowContentItemTranslationStatistics> {    
    return this._httpClient.get<FlowContentItemTranslationStatistics>(
        `${this.#apiController}/flow-content-item-translations-statistics/`,
        { params: getQueryParams(params) },
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  patchTranslation(params: PatchFlowContentReq): Observable<FlowContentItemTranslation> {
    const { id, ...body } = params;
    return this._httpClient.patch<FlowContentItemTranslation>(
        `${this.#apiController}/flow-content-item-translations/${ id }/`,
        body,
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  getFlowContent(params: FlowsLocalsReq): Observable<ListResponse<FlowContentItem>> {
    return this._httpClient.get<ListResponse<FlowContentItem>>(
        `${this.#apiController}/flow-content-items/`,
        { params: getQueryParams(params) },
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
